import { createContext } from 'react'
import { Project, ProjectMeta, Season } from '@/services/ProjectsService'
import { ProjectTheme } from '@/utils/project-themes/types'

/** Type for project that can be either Project or normalized ProjectMeta with seasons */
export type WatchContextProject = Project | (ProjectMeta & { seasons: Season[] })

export interface WatchProjectContextType {
  project: WatchContextProject
  projectTheme: ProjectTheme
  departmentPath?: string[]
}

export const WatchProjectContext = createContext<WatchProjectContextType>({
  projectTheme: {} as ProjectTheme,
  project: {} as Project,
})
